import React, { useState, useEffect } from "react"
import { toast } from "react-toastify"

import { apiCall, toPersianDigit, url_base } from '../../../Helper'

import Footer from "../Footer"
import Loading from "../Loading"
import RelatedFiles from "../RelatedFiles"
import LightBox from "../library-pages/LightBox"
import { ActionButtons } from "../ActionButtons"
import { IAGI_Rule } from "../../types/RulesLibrary.type"
import { IAGI_Law } from "../../types/index.type"

const htmlToText = require('html-to-text')

type IUser = {
  id: number
  user_name: string
  firstName: string
  lastName: string
  avatar: any
}

interface IAGI_News {
  content?: string
  file?: any[]
  id_news?: number
  image?: string
  laws?: IAGI_Law[]
  rules?: IAGI_Rule[]
  source?: any[]
  submit_date?: string
  title?: string
  update_date?: string
  updater?: number
  user?: IUser
  bookmarked?: boolean
}

export default ({ id }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [news, setNews] = useState<IAGI_News>({})
  const [showShare, setShowShare] = useState(false)

  const [showLightBox, setShowLightBox] = useState(false)
  const [lightboxActiveIndex, setLightboxActiveIndex] = useState(0)

  function getNews() {
    setIsLoading(true)
    apiCall({
      url: '/news/news',
      params: { id_news: id }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        setNews(res.data)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function setBookmark() {
    setIsLoading(true)
    apiCall({
      url: '/other/bookmark',
      method: "post",
      data: {
        _type: 6,
        target_id: id
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        getNews()
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  useEffect(() => { getNews(); }, [])

  function getShareText(tg) {
    return (
      `دیجی مالیات برترین سامانه تخصصی قوانین و مقررات کشور
      
      ${window.location.href}
      
      عنوان: ${toPersianDigit(news.title)}
      نوع : اخبار مالیاتی
      
      ${tg ? (toPersianDigit(htmlToText.fromString(news.content)).substring(0, 256) + '...') : toPersianDigit(htmlToText.fromString(news.content))}
      
      https://instagram.com/digimaliat\n`
    )
  }

  function getMailText() {
    return (
      `دیجی مالیات برترین سامانه تخصصی قوانین و مقررات کشور
      %0A%0A
      ${window.location.href}
      %0A%0A
      نوع : اخبار مالیاتی
      %0A
      عنوان: ${toPersianDigit(news.title)}
      %0A
      ${toPersianDigit(htmlToText.fromString(news.content))}
      %0A
      https://instagram.com/digimaliat`
    )
  }

  return (
    <div>
      <div className="container pt-45">
        <section className="px-64 py-45">
          <div className="radius-8 overflow-hidden">
            <img className="w-100 force" style={{ maxHeight: 620 }} src={url_base + news?.image} alt={news.title} />
            <div className="grid" style={{ gridTemplateColumns: news.file && news.file.length > 0 ? '4fr 1fr' : '' }}>
              <div className="p-32">
                <h3 className="text-shadow font-20 mt-0">{news.title}</h3>
                <div className="px-16 flexed justify-between">

                  <div className="font-12 pl-32">
                    <span>تاریخ انتشار: </span>
                    <span>{news.submit_date?.slice(0, 10)}</span>
                  </div>
                  <div className="flexed">
                    <ActionButtons
                      showShare={showShare}
                      mailText={getMailText}
                      shareText={getShareText}
                      onShare={() => setShowShare(!showShare)}
                      onBookMark={() => setBookmark()}
                      visibles={{ bookMark: true, share: true }}
                      hasBookmark={news.bookmarked}
                    />
                    {/* {showShare &&
                      <ShareComponent getShareText={getShareText} getMailText={getMailText}
                        className="flexed slideInRight absolute" style={{ left: '100%' }} />} */}
                    {/* <button className="bd-none bg-none icon-button mx-8 p-0" title="اشتراک گذاری" onClick={() => setShowShare(!showShare)}>
                      <img className="icon-sm valign-mid button" src={Share} alt="" />
                    </button> */}
                  </div>
                </div>

                {/* content */}
                <div className="pt-16" dangerouslySetInnerHTML={{ __html: news.content }} />
              </div>

              {/* related files */}
              {news.file && news.file.length > 0 && <div>
                <div className="sticky">
                  <RelatedFiles files={news.file} title="فایل های ضمیمه" onClick={(index) => {
                    setLightboxActiveIndex(index)
                    setShowLightBox(true)
                  }} />
                </div>
              </div>}
            </div>

          </div>
        </section>
      </div>

      <LightBox show={showLightBox} toggleShow={setShowLightBox} items={news.file} activeI={lightboxActiveIndex} />

      <Footer />
      <Loading show={isLoading} full />
    </div>
  )
}
